<template>
  <div class="l-page l-page--condition">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <h2 class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">
            カスタムパラメーター設定の一覧
          </div>
        </h2>
        <large-blue-button text="新規登録" @click="onAddClick" />
      </div>
      <div class="l-main-content">
        <div class="p-message-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }">
          <div class="c-loader c-loader"></div>
          <div class="c-empty">
            <div class="c-empty__text">カスタムパラメーター設定が存在しません</div>
          </div>
          <table class="c-table">
            <thead>
              <tr>
                <th class="c-table__cell--center u-w100 is-sortable" style="padding: 15px !important;">
                  <span class="c-table__text">種別</span>
                  <sort-switch name="group_name" :order="sortTargets.parameter_type" @on-click="onClickSortButton($event)" />
                </th>
                <th class="c-table__cell--center u-w100 is-sortable" style="padding: 15px !important;">
                  <span class="c-table__text">値</span>
                  <sort-switch name="relational_message_count" :order="sortTargets.parameter_value" @on-click="onClickSortButton($event)" />
                </th>
                <th class="c-table__cell--center u-w100 is-sortable" style="padding: 15px !important;">
                  <span class="c-table__text">作成日時</span>
                  <sort-switch name="group_name" :order="sortTargets.create_date" @on-click="onClickSortButton($event)" />
                </th>
              </tr>
            </thead>

            <custom-parameter-list-item
              v-for="(customParameter, index) in customParameters"
              :key="index"
              :custom-parameter="customParameter"
              @delete-click="onDeleteCustomParameter"
              @edit-click="onEdit"
            />
          </table>
          <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
        </div>
      </div>
    </main>

    <control-modal
      ref="refControlModal"
      classes="c-modal--message-delete"
      title="以下の設定を削除しますか？"
      :body="deleteConfirmMessage"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDelete
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />

  </div>
</template>

    <script>
import axios from 'axios';

export default {
  props: {
    customParameterInfo: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      customParameters: [],
      paginationInfo: null,
      isLoading: false,
      isEmpty: true,
      isLoaded: false,
      sortTargets: {
        parameter_type: 0,
        parameter_value: 0,
        create_date: 0,
      },
      currentSortTarget: null,
      currentSortOrder: null,
      isDelete: false,
      currentCustomParameter: null,
    }
  },
  computed: {
    deleteConfirmMessage: function() {
      if (this.customParameterInfo) {
        const parameterType = this.customParameterInfo.parameter_types[this.currentCustomParameter?.parameter_type];
        return `種別 : ${parameterType}\n値 : ${this.currentCustomParameter?.parameter_value}`;
      }
      return '';
    },
  },
  mounted: function() {
    this.loadData();
  },
  methods: {
    loadData: function() {
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメーター作成
      let params = {
        params: {
          groupName: this.groupName,
          relational_message_count: this.relational_message_count,
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      }

      params.page = this.page;

      axios.get('/api/custom-parameter/list', params)
        .then(res => {
          this.customParameters = res.data.customParameters.data;
          this.paginationInfo = res.data.customParameters;
          this.isLoading = false;
          this.isEmpty = this.customParameters.length === 0;
        })
        .catch(error => {
          console.log(error);
        });
    },
    onClickSortButton: function(target) {
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },
    onCloseConrolModal() {
      this.isDelete = false;
      this.$refs.refControlModal.resetErrorMessage();
    },
    onDeleteCustomParameter: function(customParameter) {
      this.currentCustomParameter = customParameter;
      this.isDelete = true;
    },
    onEnterConrolModal: function() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      // 削除処理実行
      axios.delete(`/api/custom-parameter/${this.currentCustomParameter.custom_parameter_id}`)
        .then(_res => {
          this.$refs.refControlModal.hideLoader();
          this.isDelete = false;
          this.errorMessage = ''
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage('削除に失敗しました');
          this.handleHttpError(error);
        });
    },
    onEdit: function(customParameter) {
      location.href = '/coins-admin/custom-parameter/edit/?custom_parameter_id=' + customParameter.custom_parameter_id;
    },
    onAddClick: function() {
      location.href = '/coins-admin/custom-parameter/add';
    },
  }
}
    </script>

